import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthRepository } from '../../../../state/auth.repository';
import { TrackRender } from 'app/shared/front-perfomance';

@TrackRender()
@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
})
export class HomepageComponent implements OnInit, AfterViewInit {
  constructor() {}
  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      console.log('APP_READY_HomePage');
    }, 1000);
  }

  ngAfterContentChecked() {}
}
